import { TourConfig } from '../models/tour-config.model';
import { TourFeature } from '../config/tour-feature.enum';
import { Audience } from '../config/audience.enum';
import { TourTrigger } from '../config/trigger.enum';
import { AnchorId } from '../config/anchor.registry';
import { planningReadinessBridge } from '../services/planning-readiness-bridge';

/**
 * MENTOR — Wiedervereinigung R1 (§9.4): „Schau, die App hat das selbst gemacht."
 *
 * @deprecated Seit 2026-06-16 in den Endstrang (MentorEndgame, Schritt
 * `r1-harvest`) eingegliedert. Diese eigenständige 1-Schritt-Tour sprang im
 * Resume-Pfad (Fortsetzen → R1 → Endgame) bei „1/1" zurück, zeigte ein
 * vorzeitiges „Abschließen" neben dem Weiter-CTA und wechselte den Planer-View
 * (Mitarbeiter → Muster → Mitarbeiter). Alle drei Touren sind jetzt EIN
 * durchgehender Fluss; kein CTA referenziert MentorReunite mehr. Die Tour
 * bleibt nur aus Abwärtskompatibilität registriert (Trigger nur Manual, wird
 * von nichts mehr gestartet) und kann bei Gelegenheit ganz entfernt werden.
 *
 * Ursprünglich (AP-6 / 6e): ▦-Modus via launchContext, damit das Coverage-Grid
 * sichtbar ist.
 */
function snap() {
  return planningReadinessBridge.snapshot();
}

export const MENTOR_REUNITE_TOUR: TourConfig = {
  id: TourFeature.MentorReunite,
  version: 1,
  title: 'TUTORIAL.MENTOR.REUNITE.TITLE',
  description: 'TUTORIAL.MENTOR.REUNITE.DESC',
  audience: [Audience.Admin, Audience.TeamLeader],
  triggers: [TourTrigger.Manual],
  triggerContext: { route: '/planner?view=muster' },
  statePolicy: {
    allowReplay: true,
    snoozeEnabled: true,
    cooldownHoursAfterDismiss: 72,
    cooldownHoursAfterSnooze: 24,
    suppressAfterCompletion: false,
  },
  priority: 230,
  estimatedDurationSec: 90,
  category: 'feature-discovery',
  renumberVisibleSteps: true,
  launchContext: { route: '/planner?view=muster' },
  chapters: [
    {
      id: 'reunite',
      title: 'TUTORIAL.MENTOR.REUNITE.TITLE',
      steps: [
        {
          // R1.1 — die App hat aus dem Muster konkrete Termine erzeugt (Ampel).
          // Erster Schritt des verketteten Zweigs → stabiler Container-Anker
          // (PlannerView), Coverage-Grid wird im Text erklärt.
          id: 'r1-harvest',
          anchor: AnchorId.PlannerView,
          title: 'TUTORIAL.MENTOR.REUNITE.R1.TITLE',
          // Variante datengetrieben — ABER mit Lücken-Default bei unbekanntem
          // Snapshot: Ein frisch erzeugtes Muster hat fast immer offene Lücken,
          // und faelschlich „alles besetzt" (NO_GAP) zu behaupten ist der
          // irrefuehrendere Fehler. Nur ein EXPLIZIT lückenfreier Snapshot
          // (s gesetzt && !hasPatternWithGap) zeigt die NO_GAP-Variante.
          content: () => {
            const s = snap();
            return s && !s.hasPatternWithGap
              ? 'TUTORIAL.MENTOR.REUNITE.R1.CONTENT_NO_GAP'
              : 'TUTORIAL.MENTOR.REUNITE.R1.CONTENT';
          },
          placement: 'auto',
          showNextButton: true,
          showPrevButton: false,
          actions: [
            {
              labelKey: 'TUTORIAL.MENTOR.REUNITE.R1.CTA',
              icon: 'fa-solid fa-arrow-right',
              startTour: TourFeature.MentorEndgame,
              variant: 'primary',
            },
          ],
        },
      ],
    },
  ],
};
